<template>
  <app-list
      title="Worker Platforms"
      :items-per-page="500"
      no-search-padding
      :search-by="[
        'Name',
      ]"
      show-filters
      export-query-type="workerPlatformsExport"
      :query-fields="[
        'ID',
        'Name',
        'CreatedAt',
        'UpdatedAt',
      ]"
      delete-mutation-type="deleteWorkerPlatform"
      delete-mutation-field="ids"
      delete-by="ID"
      add-link="worker_platforms/add"
      query-type="workerPlatforms"
      :row-click="onRowClick"
  >
    <template #head>
      <lth sort-by="Name" width="120">Name</lth>
      <lth sort-by="CreatedAt">Created At</lth>
      <lth sort-by="UpdatedAt" width="150">Updated At</lth>
    </template>
    <template #row="{item}">
      <ltd>{{ item.Name }}</ltd>
      <ltd date>{{ item.CreatedAt }}</ltd>
      <ltd date>{{ item.UpdatedAt }}</ltd>
    </template>
  </app-list>
</template>
<script>
export default {
  methods: {
    onRowClick: function (item) {
      this.goToPage(`worker_platforms/edit/${item.ID}`);
    },
  },

  data: () => ({}),

  mounted() {

  }
}
</script>